(()=>{
 if(window.hulkMotionReady)return;
 window.hulkMotionReady=true;
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 if(!('IntersectionObserver' in window)||!Element.prototype.animate)return;
 const seen=new WeakSet(),running=new Set();
 const observer=new IntersectionObserver(entries=>{
  for(const entry of entries){
   if(!entry.isIntersecting)continue;
   observer.unobserve(entry.target);
   entry.target.dataset.hulkReveal='done';
   if(reduced.matches||document.hidden)continue;
   const animation=entry.target.animate([{opacity:.65,translate:'0 12px'},{opacity:1,translate:'0 0'}],{duration:360,easing:'cubic-bezier(.2,.7,.3,1)'});
   running.add(animation);
   animation.finished.catch(()=>{}).finally(()=>running.delete(animation));
  }
 },{threshold:.08});
 const init=()=>{
  if(reduced.matches)return;
  document.querySelectorAll('#MainContent h2,#MainContent .dl-featured-image,#MainContent .df-outfit-media,#MainContent .dripp-category-tile,#MainContent .hs-card,#MainContent .hs-category').forEach(element=>{
   if(seen.has(element))return;
   seen.add(element);
   if(element.getBoundingClientRect().top<innerHeight)return;
   element.dataset.hulkReveal='ready';
   observer.observe(element);
  });
 };
 reduced.addEventListener('change',()=>{if(reduced.matches){observer.disconnect();running.forEach(animation=>animation.cancel())}else init()});
 document.addEventListener('shopify:section:load',init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
